import React from "react";
import PropTypes from "prop-types";

const steps = [
  "Ingreso de datos de la empresa",
  "Ingreso trabajadores",
  "Confirmación",
];

class StepsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { currentStep } = this.props;
    return (
      <div id="cotizaciones-steps-container">
        <div style={{width: "100%", position: "fixed", width: "inherit"}}>
          <div id="cotizaciones-steps-title">Nueva Cotización</div>

          <div id="cotizaciones-steps">
            {steps.map((step, index) => {
              const isStepCompleted = currentStep > index + 1;
              const isStepActive = currentStep === index + 1;
              const stepClass = isStepActive
                ? "step-number-active"
                : isStepCompleted
                ? "step-number-completed"
                : "";
              return (
                <React.Fragment key={step}>
                  <div className="cotizaciones-steps-number">
                    <div className={stepClass}>
                      {isStepCompleted ? (
                        <i className="material-icons">done</i>
                      ) : (
                        index + 1
                      )}
                    </div>
                  </div>
                  <div className="cotizaciones-steps-label">{step}</div>
                </React.Fragment>
              );
            })}
          </div>
        </div>


      </div>
    );
  }
}

StepsPanel.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

StepsPanel.defaultProps = {
  currentStep: 1,
};

export default StepsPanel;
